import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    overtimeList: {
        requesting: false,
        items: [],
        pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
	},
        error: null,
        success: false,
        filters: {},
    },
    overtimeDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
  };

export const overtimeSlice = createSlice({
    name: 'overtime',
    initialState,
    reducers: {
        getOvertimeList: (state, action) => {
            state.overtimeList.requesting = true;
            state.overtimeList.error = null;
            state.overtimeList.items = [];
            state.overtimeList.success = false;
            state.overtimeList.filters = action.payload;
        },
        getOvertimeListSuccess: (state, action) => {
            const { data, current_page, per_page, total} = action.payload;
            state.overtimeList.requesting = false;        
            state.overtimeList.items = data;
            state.overtimeList.success = true; 
            state.overtimeList.pagination.current_page = current_page;
            state.overtimeList.pagination.per_page = per_page;
            state.overtimeList.pagination.total = total;
        },
        getOvertimeListFail: (state, action) => {        
            state.overtimeList.requesting = false;
            state.overtimeList.error = action.payload;
        },
        getOvertimeDetails: (state) => {
            state.overtimeDetails.requesting = true;
            state.overtimeDetails.error = null;
            state.overtimeDetails.data = null;
            state.overtimeDetails.success = false; 
        },
        getOvertimeDetailsSuccess: (state, action) => {
            state.overtimeDetails.requesting = false;
            state.overtimeDetails.data = action.payload;
            state.overtimeDetails.success = true; 
        },
        getOvertimeDetailsFail: (state, action) => {        
            state.overtimeDetails.requesting = false;
            state.overtimeDetails.error = action.payload;
        },
        doOvertimeCreate: (state) => {
            state.overtimeDetails.requesting = true;
            state.overtimeDetails.error = null;
            state.overtimeDetails.data = null;
            state.overtimeDetails.success = false; 
        },
        doOvertimeUpdate: (state) => {
            state.overtimeDetails.requesting = true;
            state.overtimeDetails.error = null;
            state.overtimeDetails.data = null;
            state.overtimeDetails.success = false; 
        },
        doOvertimeDelete: (state) => {
            state.overtimeDetails.requesting = true;
            state.overtimeDetails.error = null;
            state.overtimeDetails.data = null;
            state.overtimeDetails.success = false; 
        },
    },
})

export const { 
    getOvertimeList, getOvertimeListSuccess, getOvertimeListFail,
    getOvertimeDetails, getOvertimeDetailsSuccess, getOvertimeDetailsFail,
    doOvertimeCreate, doOvertimeUpdate, doOvertimeDelete
} = overtimeSlice.actions

export default overtimeSlice.reducer